import { defineMessages } from 'react-intl';

const translations = {
  page: {
    title: {
      id: 'pages.overview.title',
      defaultMessage: 'Dashboard',
      description: 'title of the dashboard page',
    },
    subTitle: {
      id: 'pages.overview.subTitle',
      defaultMessage: 'Welcome, {fullName}',
      description: 'sub title of the dashboard page',
    },
  },
  sections: {
    activity: {
      title: {
        id: 'pages.overview.sections.activity.title',
        defaultMessage: 'View activity',
        description: 'title of the view activity section',
      },
      description: {
        id: 'pages.overview.sections.activity.description',
        defaultMessage: 'View your and your colleagues activity.',
        description: 'description of the view activity section',
      },
      button: {
        id: 'actions.view',
        defaultMessage: 'View',
        description: 'Button of the view activity section',
      },
    },
    editProfile: {
      title: {
        id: 'pages.overview.sections.editProfile.title',
        defaultMessage: 'Edit profile',
        description: 'title of the view edit profile section',
      },
      description: {
        id: 'pages.overview.sections.editProfile.description',
        defaultMessage: 'Edit your profile information',
        description: 'description of the view edit profile section',
      },
      button: {
        id: 'actions.edit',
        defaultMessage: 'Edit',
        description: 'button of the view edit profile section',
      },
    },
  },
};

export default defineMessages(translations);
